import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const FeriadoService = {
  async postFeriado(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "feriado",
      postData,
    );

    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule("Feriado cadastrado com sucesso.", "success");
    return true;
  },

  async editarFeriado(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "feriado",
      postData,
    );

    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule("Feriado cadastrado com sucesso.", "success");
    return true;
  },

  async putFeriado(id, postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `feriado/${id}/update`,
      postData,
    );

    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule("Feriado atualizado com sucesso.", "success");
    return true;
  },

  async getFeriados(anos = null) {
    if (anos) {
      const response = await BaseService.fetchResponseFromAPIGet(`feriados?anos=${anos}`);
      if (response.error) {
        SnackBarModule("Não foi possível buscar a lista de feriados.", "error");
      }

      return response.content;
    } else {
      const response = await BaseService.fetchResponseFromAPIGet(`feriados`);
      if (response.error) {
        SnackBarModule("Não foi possível buscar a lista de feriados.", "error");
      }

      return response.content;
    }
  },

  async getAnos() {
    const response = await BaseService.fetchResponseFromAPIGet(`lista-anos`);
    if (response.error) {
      SnackBarModule("Não foi possível buscar a lista de anos.", "error");
    }

    return response.content;
  },

  async deleteFeriado(id) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `feriado/${id}/delete`,
    );

    if (response.error) {
      SnackBarModule(
        "Não foi possível deletar o feriado.",
        "error",
      );
      return false;
    }

    SnackBarModule("O feriado foi deletada com sucesso", "success");
    return true;
  }
}